// import cx from 'classnames';
import Pattern from './Pattern';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Circles(_ref) {
  var _corners;
  let {
    id,
    width,
    height,
    radius = 2,
    fill,
    stroke,
    strokeWidth,
    strokeDasharray,
    background,
    complement = false,
    className
  } = _ref;
  let corners;
  if (complement) {
    corners = [[0, 0], [0, height], [width, 0], [width, height]];
  }
  return /*#__PURE__*/_jsxs(Pattern, {
    id: id,
    width: width,
    height: height,
    children: [!!background && /*#__PURE__*/_jsx("rect", {
      width: width,
      height: height,
      fill: background
    }), /*#__PURE__*/_jsx("circle", {
      // className={cx('visx-pattern-circle', className)}
      cx: width / 2,
      cy: height / 2,
      r: radius,
      fill: fill,
      stroke: stroke,
      strokeWidth: strokeWidth,
      strokeDasharray: strokeDasharray
    }), (_corners = corners) === null || _corners === void 0 ? void 0 : _corners.map(_ref2 => {
      let [cornerX, cornerY] = _ref2;
      return /*#__PURE__*/_jsx("circle", {
        // className={cx('visx-pattern-circle visx-pattern-circle-complement', className)}
        cx: cornerX,
        cy: cornerY,
        r: radius,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeDasharray: strokeDasharray
      }, `${id}-complement-${cornerX}-${cornerY}`);
    })]
  });
}